import {Grid, useReachGoalCallback} from '@logistics-frontend/blocks'
import {Header as AppHeader} from '@logistics-frontend/blocks/legacy'
import {Button} from '@logistics-frontend/blocks/lpc/button'
import {Typographyv2 as Typography} from '@logistics-frontend/blocks/v2'
import {useI18n} from '@logistics-frontend/core/i18n'
import React from 'react'

import {useConfig} from 'src/config'

import {User} from '../user'

const Header: React.FC = () => {
  const {lang} = useConfig()
  const t = useI18n()
  const reachGoal = useReachGoalCallback()

  return (
    <AppHeader lang={lang}>
      <Grid item>
        <Button
          aria-label={t('order.header.button_text_big', 'Доставка для Бизнеса')}
          color="secondary"
          href="/"
          onClick={() => reachGoal('Order-Button-ClickForBusiness')}
          size="small"
          // @ts-expect-error пропса target нет в типах Button, но он работает
          target="_blank"
          variant="contained"
        >
          <Typography color="invert" thickness="regular" variant="caption1">
            {t('order.header.button_text_big', 'Доставка для Бизнеса')}
          </Typography>
        </Button>
      </Grid>
      <Grid item>
        <User />
      </Grid>
    </AppHeader>
  )
}

export default Header
